export default __webpack_public_path__ + "static/media/map-pin-design-my-night.d35feb42.svg";